import React from 'react';
import cn from 'classnames';
import styles from './loading-indicator.module.scss';
export const LoadingIndicator = ({ size, centered, }) => (React.createElement("div", { "data-testid": "loading-indicator", className: cn(styles.spinner, size && styles[size], centered && styles.centered) }));
